export enum ReelsSpeedLevel {
    normal,
    turbo_1,
    turbo_2
}

export const QUICK_SKIP_THRESHOLD_FOR_TURBO_POPUP_SUGGESTION = 3;